import { Routes, Route, Navigate } from "react-router-dom";
import ImpactPlusReport from "./ImpactPlusReport";
import ImpactPlusReportsList from "./ImpactPlusReportsList";
import ImpactPlusStakeholderRegister from "./ImpactPlusStakeholderRegister";
import ImpactPlusStakeholderImpactAssessment from "./ImpactPlusStakeholderImpactAssessment";
import ImpactPlusUseCaseOverview from "./ImpactPlusUseCaseOverview";
import ImpactPlusHazards from "./ImpactPlusHazards";
import RiskPlusUseCaseOverview from "../risk-plus/RiskPlusUseCaseOverview";
import RiskPlusExecutiveSummary from "../risk-plus/RiskPlusExecutiveSummary";
import RiskPlusRiskConcentration from "../risk-plus/RiskPlusRiskConcentration";
import RiskPlusRiskDomains from "../risk-plus/RiskPlusRiskDomains";
import RiskPlusRiskFindings from "../risk-plus/RiskPlusRiskFindings";
import RiskPlusRequiredControls from "../risk-plus/RiskPlusRequiredControls";

const Impactplus = () => {
  return (
    <div className="flex flex-col h-full w-full">
      <div className="flex-1 overflow-auto">
        <Routes>
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="dashboard" element={<ImpactPlusReport />} />
          <Route path="reports" element={<ImpactPlusReportsList />} />
          <Route path="use-case/:useCaseChatId" element={<ImpactPlusUseCaseOverview />} />
          <Route
            path="use-case/:useCaseChatId/hazards"
            element={<ImpactPlusHazards />}
          />
          <Route
            path="use-case/:useCaseChatId/stakeholder-register"
            element={<ImpactPlusStakeholderRegister />}
          />
          <Route
            path="use-case/:useCaseChatId/impact-assessment"
            element={<ImpactPlusStakeholderImpactAssessment />}
          />
          <Route path="use-case/:useCaseChatId/executive" element={<RiskPlusUseCaseOverview />} />
          <Route path="use-case/:useCaseChatId/risk-executive-summary" element={<RiskPlusExecutiveSummary />} />
          <Route path="use-case/:useCaseChatId/risk-concentration" element={<RiskPlusRiskConcentration />} />
          <Route path="use-case/:useCaseChatId/deployment-risk-profile" element={<RiskPlusRiskDomains />} />
          <Route path="use-case/:useCaseChatId/risk-findings" element={<RiskPlusRiskFindings />} />
          <Route path="use-case/:useCaseChatId/risk-controls" element={<RiskPlusRequiredControls />} />
          <Route path="use-case/:useCaseChatId/:section" element={<ImpactPlusUseCaseOverview />} />
        </Routes>
      </div>
      <footer
        className="w-full shrink-0 border-t border-gray-200/90 bg-[var(--footer-background)] px-6 py-4 text-slate-700 flex flex-col sm:flex-row justify-between items-center gap-4"
      >
        <p className="text-sm">
          © {new Date().getFullYear()} - AIQURIS® All rights reserved.
        </p>
        <div className="flex items-center gap-6 text-sm">
          <a
            href="https://aiquris.com/privacy-policy/"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-gray-900 transition-colors"
          >
            Privacy Policy
          </a>
          <a
            href="https://aiquris.com/imprint/"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-gray-900 transition-colors"
          >
            Imprint
          </a>
          <a
            href="https://www.aiquris.com"
            target="_blank"
            rel="noopener noreferrer"
            className="underline hover:text-gray-900 transition-colors"
          >
            www.aiquris.com
          </a>
        </div>
      </footer>
    </div>
  );
};

export default Impactplus;

